import './SetScoreSection.css';
import { useState } from 'react';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import ButtonSteps from '../ButtonSteps/ButtonSteps';
import SetScoreComponent from './SetScoreComponent/SetScoreComponent';
import constants from '../../../../constants/constants';

const NORMAL_MAX_SCORE = 7;
const TOO_HOT_MAX_SCORE = 12;

function SetScoreSection(props) {
    const [setScore, setSetScore] = useState({});
    const numberOfSets = parseInt(props.playerOneScore) + parseInt(props.playerTwoScore);
    const [finishDisabled, setFinishDisabled] = useState(true);
    const [validationError, setValidationError] = useState('');
    const [tiedSets, setTiedSets] = useState([]);
    const [wasTooHot, setWasTooHot] = useState(false);

    const maxScore = wasTooHot ? TOO_HOT_MAX_SCORE : NORMAL_MAX_SCORE;

    const handleFinish = () => {
        props.handleFinish(setScore, wasTooHot);
    };

    const handleChange = (value) => {
        const tempSetScore = { ...setScore, [value.name]: value };

        if (Object.keys(tempSetScore).length === numberOfSets * 2) {
            let isAnyTieInput = false;
            let playerOneSetsWon = 0;
            let playerTwoSetsWon = 0;
            let currentTiedSets = [];

            for (let i = 1; i <= numberOfSets; i++) {
                const playerOneSetScore = parseInt(tempSetScore[`player-one-set-${i}`].value);
                const playerTwoSetScore = parseInt(tempSetScore[`player-two-set-${i}`].value);

                if (playerOneSetScore === playerTwoSetScore) {
                    isAnyTieInput = true;
                    currentTiedSets.push(i);
                } else if (playerOneSetScore > playerTwoSetScore) {
                    playerOneSetsWon++;
                } else {
                    playerTwoSetsWon++;
                }
            }

            setTiedSets(currentTiedSets);

            if (isAnyTieInput) {
                setValidationError(constants.ADD_GAME.SET_SCORE_TIE_ERROR);
                setFinishDisabled(true);
            } else if (
                playerOneSetsWon !== parseInt(props.playerOneScore) ||
                playerTwoSetsWon !== parseInt(props.playerTwoScore)
            ) {
                setValidationError(constants.ADD_GAME.SET_SCORE_MISMATCH_ERROR);
                setFinishDisabled(true);
            } else {
                setValidationError('');
                setFinishDisabled(false);
            }
        } else {
            setValidationError('');
            setTiedSets([]);
        }
        setSetScore(tempSetScore);
    };

    const handleTooHotChange = (event) => {
        setWasTooHot(event.target.checked);
        // Reset scores so no stale value above the new max lingers in the selects.
        setSetScore({});
        setValidationError('');
        setTiedSets([]);
        setFinishDisabled(true);
    };

    const renderComponents = () => {
        const components = [];
        for (let i = 1; i <= numberOfSets; i++) {
            components.push(
                <SetScoreComponent
                    key={`${i}-${wasTooHot}`}
                    handleChange={handleChange}
                    keyNumber={i}
                    hasError={tiedSets.includes(i)}
                    maxScore={maxScore}
                />
            );
        }
        return components;
    };

    return (
        <div className='set-score-section-container'>
            <div className='set-score-too-hot-row'>
                <FormControlLabel
                    className='set-score-too-hot-label'
                    control={<Switch checked={wasTooHot} onChange={handleTooHotChange} />}
                    label={constants.ADD_GAME.TOO_HOT_LABEL}
                />
            </div>
            <div className='set-score-header-row row'>
                <div className='col-4' />
                <div className='col-4 set-score-header-cell'>
                    <span className='set-score-player-name'>{`${props.playerInContext.firstName} ${props.playerInContext.lastName}`}</span>
                </div>
                <div className='col-4 set-score-header-cell'>
                    <span className='set-score-player-name'>{`${props.playerOne.firstName} ${props.playerOne.lastName ?? ''}`}</span>
                </div>
            </div>
            {renderComponents()}
            {validationError && <div className='set-score-validation-error'>{validationError}</div>}
            <ButtonSteps
                isBackDisabled={false}
                isFinalStep={true}
                isContinueDisabled={finishDisabled}
                handleNext={handleFinish}
                handleBack={props.handleBack}
            />
        </div>
    );
}

export default SetScoreSection;
